import { render, staticRenderFns } from "./error-box.vue?vue&type=template&id=3dcc3f3f&"
import script from "./error-box.vue?vue&type=script&lang=js&"
export * from "./error-box.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports